
import { ReactNode } from 'react';

interface SettingRowProps {
  title: string;
  description?: string;
  children: ReactNode;
  stacked?: boolean;
}

const SettingRow = ({ title, description, children, stacked = false }: SettingRowProps) => {
  if (stacked) {
    return (
      <div className="py-4 border-b border-recallio-light-gray/50 last:border-0 last:pb-0 first:pt-0">
        <div className="mb-3">
          <h4 className="font-medium">{title}</h4>
          {description && <p className="text-muted-foreground text-sm mt-1">{description}</p>}
        </div>
        <div>
          {children}
        </div>
      </div>
    );
  }
  
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between py-4 border-b border-recallio-light-gray/50 last:border-0 last:pb-0 first:pt-0">
      <div className="mb-3 sm:mb-0">
        <h4 className="font-medium">{title}</h4>
        {description && <p className="text-muted-foreground text-sm mt-1">{description}</p>}
      </div>
      <div className="sm:flex sm:items-center">
        {children}
      </div>
    </div>
  );
};

export default SettingRow;
